export default {
    type: 'person-podcasts',
    aliases: {
        camel: 'personPodcasts',
        singular: 'Person podcast',
        plural: 'Person podcasts',
        lowerSingular: 'person podcast',
        lowerPlural: 'person podcasts',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
